import {QuestionModelV3, GuessModelV1, DraftGuessModelV1} from '@albert-io/models';
import {Draft} from 'immer';
import makeConstants from 'lib/makeConstants';

export enum SaveStatus {
  DEFAULT,
  LOADING,
  LOAD_ERROR,
  SAVED,
  SAVE_ERROR,
  SAVING
}

// FOR ZUSTAND STORE usage

export const allSaveStatuses = [
  'default',
  'loading',
  'loadError',
  'saved',
  'saveError',
  'saving'
] as const;

export const saveStatus = makeConstants(...allSaveStatuses);

export namespace QuestionType {
  export type SaveStatus = (typeof allSaveStatuses)[number];
  export interface CoreState {
    // Question data
    question: QuestionModelV3 | null;
    questionId: string | null;
    correctAnswer: Record<string, string> | null;
    // Draft guess state
    draftGuess: DraftGuessModelV1 | null;
    lastSaveTime: number | null;
    // Guess info
    guess: GuessModelV1 | null;
    isSubmitted: boolean;
  }

  export interface CoreActions {
    addQuestionInfo: (question: QuestionModelV3) => void;
    addDraftGuessInfo: (draftGuess: DraftGuessModelV1) => void;
    addGuessInfo: (guess: GuessModelV1) => void;
    // Draft guess actions
    buildGuessContent: () => Record<string, string>;
  }
}

export type CoreQuestionStore = QuestionType.CoreState & QuestionType.CoreActions;

export type SetStateWithImmer<T> = (
  nextState: T | Partial<T> | ((state: Draft<T>) => void),
  replace?: boolean,
  name?: string
) => void;
